import * as actions from './actions';

const initialState = {
    tips: [],
    currentTipIndex: 0,
    error: null,
    initial: false,
    loading: false,
};

const cultivationTipsReducer = (state = initialState, action) => {
    switch (action.type) {
        case actions.FETCH_CULTIVATION_TIPS.REQUEST:
            return { ...state, loading: true, error: null };

        case actions.FETCH_CULTIVATION_TIPS.SUCCESS: {
            const { tips } = action.payload;
            return { ...state, loading: false, initial: true, tips, currentTipIndex: 0 };
        }

        case actions.FETCH_CULTIVATION_TIPS.FAILURE:
            return { ...state, loading: false, initial: false, error: action.payload.error };

        default:
            return state;
    }
};

export default cultivationTipsReducer;
